export default {"src":"/_next/static/media/404ErrorLight.0fd09d9e.svg","height":180,"width":180,"blurWidth":0,"blurHeight":0};